module.exports = __webpack_public_path__ + "img/icon-subscribe-3.aade6ba5.svg";